import createStaticResourceAPI from "@/helpers/rtk_static_resource_factory";

const baseURL = process.env.REACT_APP_GLOBO_API + '/transactions/prescriptionRequests';
const type = "PrescriptionRequests";

export const prescriptionRequestsAPI = createStaticResourceAPI({
  baseURL: baseURL,
  resource: "PrescriptionRequests",
  tagTypes: ["PrescriptionRequests"],
  idKey: "prescriptionRequestId",
  lookupMap: ({ prescriptionRequestId, referenceNo }) => ({
    value: prescriptionRequestId,
    label: referenceNo
  }),
  customQuery: (query, { idKey, resource, baseURL }) => ({
    getListPrescriptionRequestsForViewers: query(`${baseURL}/listForViewer`, {
      serializeQueryArgs: ({ endpointName }) => endpointName,
      providesTags: (result) => {
        if (!result?.success || !Array.isArray(result.returnData)) {
          return [{ type: resource, id: "LIST" }];
        }

        return [
          ...result.returnData.map((item) => ({
            type: resource,
            id: item[idKey],
          })),
          { type: resource, id: "LIST" },
        ];
      }
    }),
    getFilesPrescriptionRequests: query(`${baseURL}/files/list`, {
      serializeQueryArgs: ({ endpointName }) => endpointName,
      providesTags: (result) =>
        result?.success
          ? [...(result?.items || result?.returnData)?.map((item) => ({ type: type, id: item[idKey] })), { type: type, id: type }]
          : [{ type: type, id: type }],
    }),
  }),
  customMutations: (mutation, mutationOptions) => ({
    submitPrescriptionRequests: mutation(`${baseURL}/submit`, mutationOptions("save")),
    returnPrescriptionRequests: mutation(`${baseURL}/return`, mutationOptions("save")),
    approvePrescriptionRequests: mutation(`${baseURL}/approve`, mutationOptions("save")),
    rejectPrescriptionRequests: mutation(`${baseURL}/reject`, mutationOptions("save")),
    cancelPrescriptionRequests: mutation(`${baseURL}/cancel`, mutationOptions("save")),
     filesUploadPrescriptionRequests: mutation(`${baseURL}/files/upload`),
    filesDeletePrescriptionRequests: mutation(`${baseURL}/files/delete`),
  
  }),
});

export const {
  useGetPrescriptionRequestsQuery,
  useGetListPrescriptionRequestsForViewersQuery,
  useExportPrescriptionRequestsMutation,
  useFindPrescriptionRequestsQuery,
  useLookUpPrescriptionRequestsMutation,
  useSavePrescriptionRequestsMutation,
  useSubmitPrescriptionRequestsMutation,
  useReturnPrescriptionRequestsMutation,
  useApprovePrescriptionRequestsMutation,
  useRejectPrescriptionRequestsMutation,
  useCancelPrescriptionRequestsMutation,
  useDeletePrescriptionRequestsMutation,
   useFilesUploadPrescriptionRequestsMutation,
    useFilesDeletePrescriptionRequestsMutation,
     useGetFilesPrescriptionRequestsQuery
} = prescriptionRequestsAPI;
